import { CoherenceNav, INavLinkGroup } from "@coherence-design-system/controls";
import React from "react";
import { RouteComponentProps, matchPath } from "react-router";
import { withRouter } from "react-router-dom";

const NavBar = (props: RouteComponentProps) => {
  const navLinkGroups: INavLinkGroup[] = [
    {
      key: "group1",
      links: [
        {
          name: "Create or edit a menu",
          icon: "FieldNotChanged",
          key: "MenuManagement",
          ariaLabel: "Create or edit a menu",
          onClick: () => {
            props.history.push("/menus");
          },
          isSelected: !!matchPath(props.location.pathname, "/menus"),
        },
        {
          name: "Manage images",
          icon: "Photo2",
          key: "ImageManagement",
          ariaLabel: "Manage images",
          onClick: () => {
            props.history.push("/images");
          },
          isSelected: !!matchPath(props.location.pathname, "/images"),
        },
        {
          name: "Cafe Sync",
          icon: "Sync",
          key: "CafeSync",
          ariaLabel: "Cafe Sync",
          onClick: () => {
            props.history.push("/cafeSync");
          },
          isSelected: !!matchPath(props.location.pathname, "/cafeSync"),
        },
      ],
    },
  ];

  return (
    <CoherenceNav
      appName={"Chef's Menu"}
      groups={navLinkGroups}
      defaultIsNavCollapsed={true}
      changeOpenStateOnResize={false}
    />
  );
};

export default withRouter(NavBar);
